module.exports = __webpack_public_path__ + "static/media/Logo_PLN_Naranja.29074f2f.jpg";